export default __webpack_public_path__ + "static/places-049eff39a7fc2cacd62b166355d59d02.png";